export default (function (_ref) {
  var request = _ref.request;
  return {
    sourceReportAdd: function sourceReportAdd(data) {
      return request({
        url: '/source/report/add',
        method: 'post',
        data: data
      });
    },
    sourceReportModify: function sourceReportModify(data) {
      return request({
        url: "/source/report/".concat(data.id, "/modify"),
        method: 'put',
        data: data
      });
    },
    sourceReportDel: function sourceReportDel(id) {
      return request({
        url: "/source/report/".concat(id, "/del"),
        method: 'delete'
      });
    },
    sourceReportQuery: function sourceReportQuery(data) {
      return request({
        url: '/source/report/query',
        method: 'get',
        params: data
      });
    },
    sourceReportDetail: function sourceReportDetail(id) {
      return request({
        url: "/source/report/".concat(id, "/detail"),
        method: 'get'
      });
    }
  };
});